module.exports = __webpack_public_path__ + "img/link_icon_3.5114681.png";